/**
 * ServicesReportTable — топ услуг клиники по убыванию выручки с долей
 * в общей сумме (полоска-индикатор).
 */

import type {ServiceReportRow} from '@services/reports';
import {formatNumber} from '@utils/format';

type Props = {rows: ServiceReportRow[]};

export const ServicesReportTable = ({rows}: Props) => {
  const max = Math.max(1, ...rows.map((r) => r.revenue));
  return (
    <div className="overflow-hidden rounded-[15px] border border-skr-line bg-card">
      <div className="border-b border-skr-line2 px-[18px] py-3.5 text-[13.5px] font-semibold">
        Топ услуг
      </div>
      <div className="flex flex-col">
        {rows.map((r, i) => (
          <div
            key={r.serviceId ?? `null-${i}`}
            className="flex items-center gap-3.5 border-b border-skr-hairline px-[18px] py-[11px] last:border-b-0"
          >
            <span className="w-5 shrink-0 font-mono text-xs text-skr-faint">{i + 1}</span>
            <div className="min-w-0 flex-1">
              <div className="flex items-baseline justify-between gap-3">
                <span className="truncate text-[13px] font-medium text-foreground">{r.name}</span>
                <span className="shrink-0 font-mono text-[13px] font-semibold">
                  {formatNumber(r.revenue)}
                </span>
              </div>
              <div className="mt-1.5 flex items-center gap-2.5">
                <div className="h-[5px] flex-1 overflow-hidden rounded-[3px] bg-skr-line2">
                  <div
                    className="h-full rounded-[3px] bg-primary/70"
                    style={{width: `${Math.round((r.revenue / max) * 100)}%`}}
                  />
                </div>
                <span className="shrink-0 font-mono text-[11px] text-skr-faint">×{r.count}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
